<div
  class="wk-modal wk-modal-opened"
  aria-hidden="false"
  *ngIf="showContent"
  hasOverlayClickClose="true"
>
  <div class="wk-modal-content wk-update-property-modal">
    <header class="wk-modal-header">
      <div class="wk-modal-title" tabindex="-1">{{ 'APP.DIALOGS.UPDATE_PROPERTY_DIALOG.TITLE' | translate }}</div>
      <button
        type="button"
        class="wk-modal-close wk-button wk-button-icon wk-button-close"
        (click)="closeDialog()"
        (keyup.enter)="closeDialog()"
      >
        <span class="wk-icon-filled-close" aria-hidden="true"></span>
        <span class="wk-sr-only">{{ 'APP.ACTIONS.CLOSE' | translate }}</span>
      </button>
    </header>
    <div class="wk-modal-body">
      <div class="wk-update-property-form">
        <div class="wk-update-property-field">
          <label class="wk-update-property-label" for="propertyName">{{ 'APP.DIALOGS.UPDATE_PROPERTY_DIALOG.PROPERTY_NAME' | translate }}</label>
          <input
            id="propertyName"
            type="text"
            class="wk-update-property-input"
            [placeholder]="'APP.DIALOGS.UPDATE_PROPERTY_DIALOG.PROPERTY_NAME_PLACEHOLDER' | translate"
            [(ngModel)]="propertyName"
          />
        </div>
        <div class="wk-update-property-field">
          <label class="wk-update-property-label" for="propertyValue">{{ 'APP.DIALOGS.UPDATE_PROPERTY_DIALOG.PROPERTY_VALUE' | translate }}</label>
          <textarea
            id="propertyValue"
            class="wk-update-property-textarea"
            [placeholder]="'APP.DIALOGS.UPDATE_PROPERTY_DIALOG.PROPERTY_VALUE_PLACEHOLDER' | translate"
            [(ngModel)]="propertyValue"
            rows="6"
          ></textarea>
        </div>
      </div>
    </div>
    <footer class="wk-modal-footer">
      <div class="wk-button-group wk-button-group-right">
        <button
          type="button"
          class="wk-button wk-button-text"
          (click)="closeDialog()"
          (keyup.enter)="closeDialog()"
        >
          {{ 'APP.COMMON.CANCEL' | translate }}
        </button>
        <button
          type="button"
          class="wk-button wk-button-small"
          [disabled]="!propertyName || !propertyValue"
          (click)="updateProperty()"
        >
          {{ 'APP.DIALOGS.UPDATE_PROPERTY_DIALOG.UPDATE_BUTTON' | translate }}
        </button>
      </div>
    </footer>
  </div>
</div>
